<template>
  <div>
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="12">
            <div class="clearfix">
              <h1 class="float-left text-h2 mr-4">
                Ecall - 404
              </h1>
              <h4 class="pt-3">Oops! You're lost.</h4>
              <p class="text-muted">
                The page you are looking for was not found.
              </p>
            </div>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="fa fa-search"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <input
                  id="prependedInput"
                  class="form-control"
                  size="16"
                  type="text"
                  placeholder="What are you looking for?"
              />
              <b-input-group-append>
                <b-button variant="info">Search</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
